<div class="waiting-hours-picker" *ngIf="hours.length > 0">
  <ion-label class="picker-label">How many waiting hours?</ion-label>
  <div class="chips" role="radiogroup" aria-label="Waiting hours">
    <button
      type="button"
      class="chip"
      *ngFor="let h of hours; trackBy: trackByHour"
      [class.chip--active]="h === selectedHours"
      role="radio"
      [attr.aria-checked]="h === selectedHours"
      (click)="selectHour(h)"
    >
      {{ h }}h
    </button>
  </div>

  <div class="subtotal" *ngIf="subtotal > 0">
    + {{ subtotal | currency:'USD':'symbol':'1.2-2' }} waiting fee
  </div>
</div>
